import React from 'react';
import { Link } from 'react-router-dom';
import './WordListTitle.css';

const WordListTitle = ({ icon, title, heading, description }) => {
  return (
    <div className="word-list-container">
      <div className="word-list-header">
        <span className="word-list-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
            <path d="M7 7h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
          </svg>
        </span>
        <Link to="/#collections" className="word-list-title-link">
          <h2 className="word-list-title">{title}</h2>
        </Link>
      </div>

      <div className="word-list-banner">
        <h1 className="word-list-heading">{heading}</h1>
      </div>

      <div className="word-list-description">
        <p>{description}</p>
      </div>
    </div>
  );
};

export default WordListTitle; 